<template>
  <div class="card" @click="gotoDetail(material.id)">
    <div class="ad-img">
      <span
        class="bg"
        data-src="https://bbacdn-idea3-cn.uncledesk.com/sp_opera/25d5e6f0ca45c3dab8ade185bc540dd4.jpg"
        lazy="loaded"
        :style="{ backgroundImage: 'url(' + material.imageurl + ')' }"
      ></span>
      <el-image :src="material.imageurl" fit="contain"></el-image>
    </div>
    <div class="ad-info">
      <!-- <div class="logo">
                  <img
                    src="https://bbacdn-logo-cn.uncledesk.com/sp_opera/587c37488cb060f2dffa18bc0cc9a684.ico"
                    alt=""
                  />
                </div> -->
      <div class="docs-box">
        <p class="docs bold"></p>
        <div class="ad-cat">
          <!-- <p v-for="(sub_item, index) in item.classl1" :key="index">
                      <span v-if="index < 2">
                        {{ sub_item }} |
                        {{ item.classl2 ? item.classl2[index] : "" }}
                      </span>
                    </p>
                    <span v-if="item.classl1.length > 2">
                      <el-popover placement="right" trigger="hover">
                        <span
                          v-for="(sub_item, index) in item.classl1.slice(2)"
                          :key="index"
                        >
                          {{ sub_item }} |
                          {{ item.classl2 ? item.classl2[index] : "" }}
                        </span>
                        <span slot="reference">...</span>
                      </el-popover>
                    </span> -->
          <p v-for="(sub_item, index) in material.classl2" :key="index">
            <span> {{ sub_item }} </span
            ><span v-if="index < material.classl2.length - 1"> | </span>
          </p>
        </div>
      </div>
    </div>
    <div class="ad-time-box">
      <p class="time">{{ material.starttime }}~{{ material.endtime }}</p>
      <div class="ad-master">
        <img
          class="icon"
          v-if="material.platform == '头条'"
          src="../assets/img/头条.png"
          alt=""
        />
        <img class="icon" v-else src="../assets/img/优量汇.png" alt="" />
      </div>
    </div>
    <div class="ad-data">
      <div class="data1">
        <span class="bold">{{ material.showDayNum }}</span>
        <p>投放天数</p>
      </div>
      <div class="data2">
        <span class="bold">{{ material.showNum }}</span>
        <p>展现次数</p>
      </div>
      <div class="data3">
        <span class="bold">{{ (material.clickRate * 100).toFixed(2) }}%</span>
        <p>点击率</p>
      </div>
      <div class="data4">
        <el-popover placement="top" trigger="hover">
          <div class="device-num">
            <div class="device-display">
              <span class="bold">{{ material.deviceNum }}</span>
              <p>展示设备数</p>
            </div>
            <div class="device-click">
              <span class="bold">{{ material.clickDeviceNum }}</span>
              <p>点击设备数</p>
            </div>
          </div>
          <div slot="reference">
            <span class="bold">{{ material.deviceNum }}</span>
            <p>设备数</p>
          </div>
        </el-popover>
      </div>
      <div class="data5">
        <span class="bold">{{
          !!material.ecpm ? "￥" + material.ecpm.toFixed(2) : "--"
        }}</span>
        <p>eCPM</p>
      </div>
    </div>
    <div class="ad-detail">
      <el-button>查看详情</el-button>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MaterialItem extends Vue {
  @Prop() material;
  gotoDetail(id) {
    let { href } = this.$router.resolve({
      path: "/ad-detail",
      query: { id: id },
    });
    window.open(href, "_blank");
  }
  getIcon(icon) {
    return "../assets/img/" + icon + ".png";
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.device-num {
  display: flex;
  text-align: center;
  gap: 10px;
}
.card {
  box-sizing: border-box;
  margin-bottom: 60px;
  position: relative;
  font-size: 12px;
  border: 1px solid #ddd;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  width: 390px;
  height: 390px;
  background-color: #fff;
  margin-right: 15px;
  .bold {
    font-weight: 600;
  }
  p {
    margin: 0;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    text-align: left;
  }

  .ad-img {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 219px;
    .bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 140%;
      height: 140%;
    }
    .bg:after,
    .bg:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: #ebeef5;
      background-image: inherit;
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: cover;
      content: "";
      filter: blur(10px);
    }
    .el-image {
      height: 100%;
      height: 219px;
      display: block;
    }
    border-bottom: 1px solid #d7d7d7;
  }
  .ad-info {
    display: flex;
    padding: 0px 8px;

    .logo {
      margin-right: 20px;

      img {
        width: 4 0px;
        height: 40px;
        margin-top: 12px;
      }
    }
    .ad-cat {
      margin: 5px 0;
      height: 21px;
      line-height: 21px;
      p {
        display: inline-block;
        margin-right: 5px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        line-height: 20px;
      }
    }
  }
  .ad-time-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .time {
      padding: 8px 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 20px;
    }
    .icon {
      padding: 0px 8px;
      width: 26px;
      height: 26px;
    }
  }
  .ad-data {
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #f2f2f2;
    padding-top: 20px;
    > div {
      text-align: center;
    }

    .bold {
      font-size: 20px;
      font-family: DINCond-Bold, DINCond;
      font-weight: bold;
      color: #222222;
      line-height: 28px;
    }
    p {
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 20px;
    }
  }
  .ad-detail {
    margin: 10px 0;
    height: 40px;
    width: 100%;
    text-align: center;
    position: relative;
    display: none;
  }
}
.card:hover {
  height: 430px;
  box-shadow: 0 0 10px rgb(13 47 80 / 30%);
  transform: scale(1.04);
  z-index: 5;
  margin-bottom: 10px;

  .ad-detail {
    display: block;
  }
}
</style>
